<template>
	<div id="container" class="container">
		<myheader></myheader>
		<div class="top-banner vcenter minwidth">
			<div class="mx1360 vcenter">
				<div class="text1">为每一件艺术品 赋予可信的数字资产身份</div>
				<div class="text2 vcenter">
					基于区块链与微观物证技术，我们提供“确真、确权、确价”三位一体的资产化服务
				</div>
				<div class="btnbox align-c">
					<div @click="goPage('/solution')" class="btn1 vcenter cur curadm">立刻备案我的艺术品</div>
					<div @click="goPage('/assetDatabase')" class="btn1 white cur curadm vcenter">查询资产数据库
						>></div>
				</div>
			</div>
		</div>
		<div class="mx1360 main-count1">
			<el-row :gutter="20" :type="colwrap ? '' : 'flex'">
				<el-col :xs="24" :sm="24" :md="12" :lg="8">
					<div class="item item1 vcenter">
						<div class="pd vcenter">
							<div class="t">{{ baseInfo.cnt1 || 0 }}+</div>
							<div class="t2">已备案资产</div>
						</div>
					</div>
				</el-col>
				<el-col :xs="24" :sm="24" :md="12" :lg="8">
					<div class="item item2 vcenter">
						<div class="pd vcenter">
							<div class="t">￥{{ baseInfo.cnt2 ? baseInfo.cnt2 : "0亿" }}+</div>
							<div class="t2">已评估资产总值</div>
						</div>
					</div>
				</el-col>
				<el-col :xs="24" :sm="24" :md="12" :lg="8">
					<div class="item item3 vcenter">
						<div class="pd vcenter">
							<div class="t">{{ baseInfo.cnt3 || 0 }}+</div>
							<div class="t2">合作金融与司法机构</div>
						</div>
					</div>
				</el-col>
			</el-row>
		</div>


		<!-- list1 -->
		<div class="mx1360 main-list">
			<div class="main-title">价值发现:不止于备案,更在于洞察</div>
			<div class="main-subtitle">每日精选已完成“数字护照”认证的代表性资产展示其背后的艺术、市场与数据价值</div>
			<div class="main-ysplist">
				<ul class="between">
					<li @click="goDetail(e)" v-for="(e, i) in artslist" class="cur curadm">
						<img :src="e.img" class="p cover" />
						<div class="t hideLine1">{{ e.goods_name || '' }}</div>
						<div class="t2 hideLine1">{{ e.artist_name || '' }}</div>
					</li>
				</ul>
			</div>
			<div class="bot-btn vcenter">
				<div @click="goPage('/assetDatabase')" class="more vcenter cur curadm">了解更多 >></div>
			</div>
		</div>

		<div class="main-ad1 minwidth main-itembg">
			<div class="mx1360">
				<div class="main-title">三大核心服务 构建信任闭环</div>
				<div class="main-subtitle">从科学鉴定到价值流转，我们提供全生命周期的资产化解决方案</div>
				<div class="sdhx-box align-c">
					<div class="item item1 vcenter">
						<img class="sdhx-icon" src="@/static/new/icon_sdhx_kxjz.png" alt="">
						<div class="sdhx-title">
							科学鉴证·确真
						</div>
						<div class="sdhx-text">
							结合物理DNA与人机协同审核，出具权威鉴定报告，让真品无可争议。
						</div>
					</div>
					<div class="item item2 vcenter">
						<img class="sdhx-icon" src="@/static/new/icon_sdhx_qkl.png" alt="">
						<div class="sdhx-title">
							区块链存证·确权
						</div>
						<div class="sdhx-text">
							为资产盖上“数字钢印”，写入环太湖链，每一次流转都有迹可循。
						</div>
					</div>
					<div class="item item3 vcenter">
						<img class="sdhx-icon" src="@/static/new/icon_sdhx_qxmx.png" alt="">
						<div class="sdhx-title">
							全息模型评估·确价
						</div>
						<div class="sdhx-text">
							通过DeepArt AI引擎，融合多维数据，提供动态、可解释的科学价值参考。
						</div>
					</div>
				</div>
			</div>

		</div>

		<div class="main-ad2 minwidth">
			<div class="mx1360">
				<div class="main-title">科学鉴证·确真</div>
				<div class="main-subtitle">从源头解决信任问题，为每一件艺术品建立科学的“身份ID”</div>

				<div class="z-adlist between">
					<div class="adlist-li adl1">
						<div class="li-text">专家掌眼</div>
					</div>
					<div class="adlist-li adl2">
						<div class="li-text">微观物证档案</div>
					</div>
					<div class="adlist-li adl3">
						<div class="li-text">PUF芯片锁定</div>
					</div>
				</div>

			</div>

		</div>

		<div class="main-ad3 minwidth main-itembg">
			<div class="mx1360">
				<div class="main-title">区块链存证·确权</div>
				<div class="main-subtitle">利用分布式账本技术，为资产权属提供不可篡改的法律保障</div>


				<div class="dm-box flex-c-c-c">
					<div class="dm-main">
						<div class="dm-img-box">
							<img class="dm-img" src="../../static/new/index_qklcz_b.webp" alt="">
						</div>
						<div class="info-main">
							<div class="list-title">
								<div class="left-t">
									<div class="t1">核心优势</div>
									<div class="t2">Core advantages</div>
								</div>
								<div class="right-arrow">
									<i class="el-icon-arrow-down"></i>
								</div>
							</div>
							<ul class="list-box">
								<li class="list-li">
									<div class="img-box">
										<img src="@/static/zcsjk_icon_edit.png" class="icon-img" />
									</div>
									<div class="text-box">
										<div class="title-box">资产登记与存证</div>
										<div class="des-box">
											生成唯一且合法的数字身份和交易地址
										</div>
									</div>
								</li>
								<li class="list-li">
									<div class="img-box">
										<img src="@/static/new/index_icon_hgshlc.png" class="icon-img" />
									</div>
									<div class="text-box">
										<div class="title-box">合规审核流程</div>
										<div class="des-box">
											确保每一件上链资产的来源、内容合法合规
										</div>
									</div>
								</li>
								<li class="list-li">
									<div class="img-box">
										<img src="@/static/new/index_icon_bqbhywq.png" class="icon-img" />
									</div>
									<div class="text-box">
										<div class="title-box">版权保护与维权</div>
										<div class="des-box">
											提供一站式版权服务，全方位保护创作者权益
										</div>
									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>


			</div>

		</div>


		<div class="main-ad4 minwidth">
			<div class="mx1360">
				<div class="main-title">全息模型评估·确价</div>
				<div class="main-subtitle">以数据驱动价值发现，提供客观、公正、科学的量化评估</div>

				<div class="z-adlist4">
					<div class="adlist4-li">
						<img src="@/static/new/z-adimg4-1.webp" class="p" />
						<div class="li-t1">多维价值雷达图</div>
					</div>
					<div class="adlist4-li">
						<img src="@/static/new/z-adimg4-2.webp" class="p" />
						<div class="li-t2">动态市场数据分析</div>
					</div>
				</div>

			</div>
		</div>

		<div class="main-ad5 minwidth main-itembg">
			<div class="mx1360">
				<div class="main-title">赋能机构·服务对象</div>
				<div class="main-subtitle">我们的服务为以下机构与个人创造核心价值</div>

				<div class="z-adlist5">
					<ul class="between">
						<li>
							<img src="@/static/new/z-adimg5-1.jpg" class="p" />
							<div class="tbox anim">
								<div class="t">金融机构</div>
								<div class="t2">Financial institutions</div>
							</div>
						</li>
						<li>
							<img src="@/static/new/z-adimg5-2.png" class="p" />
							<div class="tbox anim">
								<div class="t">文博机构</div>
								<div class="t2">Cultural Heritage Institutions</div>
							</div>
						</li>
						<li>
							<img src="@/static/new/z-adimg5-3.png" class="p" />
							<div class="tbox anim">
								<div class="t">拍卖行/画廊</div>
								<div class="t2">Auction Houses / Galleries</div>
							</div>
						</li>
						<li>
							<img src="@/static/new/z-adimg5-4.png" class="p" />
							<div class="tbox anim">
								<div class="t">高净值藏家</div>
								<div class="t2">HNW Collectors</div>
							</div>
						</li>
					</ul>

				</div>

			</div>
		</div>

		<!-- <div class="main-ad6 minwidth">
			<div class="mx1360">
				<div class="main-title">成功备案案例</div>
				<div class="main-subtitle">见证实物资产到数字资产的蜕变</div>
				
				<div class="z-adlist6">
					<ul class="between">
						<li class="cur curadm">
							<img src="@/static/new/img1.jpg" class="p cover"/>
							<div class="tbox">
								<div class="t1">清·雍正斗彩瓷碗</div>
								<div class="t2 hideLine2">Doucai porcelain bowl from the Yongzheng reign of the Qing Dynasty</div>
							</div>
						</li>
						<li class="cur curadm">
							<img src="@/static/new/img1.jpg" class="p cover"/>
							<div class="tbox">
								<div class="t1">清·雍正斗彩瓷碗</div>
								<div class="t2 hideLine2">Doucai porcelain bowl from the Yongzheng reign of the Qing Dynasty</div>
							</div>
						</li>
						<li class="cur curadm">
							<img src="@/static/new/img1.jpg" class="p cover"/>
							<div class="tbox">
								<div class="t1">清·雍正斗彩瓷碗</div>
								<div class="t2 hideLine2">Doucai porcelain bowl from the Yongzheng reign of the Qing Dynasty</div>
							</div>
						</li>
					</ul>
				</div>
				
			</div>
		</div> -->


		<div class="main-ad7 minwidth main-itembg">
			<div class="mx1360">
				<div class="main-title">专家团队与权威伙伴</div>
				<div class="main-subtitle">专业与权威，是我们对您的承诺</div>

				<div class="zjlist" v-if="prolist.length > 0">
					<ul class="between">
						<li v-for="v, k in prolist" :key="v.id">
							<img :src="v.fileList[0].url" class="p cover" />
							<div class="t">{{ v.title || '' }}</div>
							<div class="t2">{{ v.subtitle || '' }}</div>
						</li>
						<li class="blank"></li>
						<li class="blank"></li>
						<li class="blank"></li>
					</ul>

				</div>

				<div class="wline" v-if="prolist.length > 0"></div>

				<div class="main-jglist between">
					<div class="item vcenter" v-for="v, k in partnerlist" :key="k">
						<img :src="v.fileList[0].url" class="p cover" />
					</div>
					<div class="item blank"></div>
					<div class="item blank"></div>
					<div class="item blank"></div>
				</div>


			</div>
		</div>

		<div class="main-ad8 vcenter minwidth">
			<div class="mx1360 vcenter">
				<div class="text1">让您的珍藏，成为可信的流通资产</div>
				<div class="text2">立即开启您艺术品的价值发现之旅</div>
				<div class="btnbox align-c">
					<div @click="goPage('/solution')" class="btn1 white vcenter cur curadm">立刻备案我的艺术品</div>
				</div>
			</div>
		</div>




		<!-- <div class="main-sdhx minwidth">
			<div class="mx1360 pd vcenter">
				<div class="title"><span class="green">三大核心服务</span>，构建信任闭环</div>
				<div class="sub-title">从科学鉴定到价值流转，我们提供全生命周期的资产化解决方案</div>
				<ul class="list">
					<el-row :gutter="0" :type="colwrap?'':'flex'">
						<el-col :xs="24" :sm="24" :md="12" :lg="8">
							<li class="vcenter">
								<img src="@/static/z-icon-s1.png" class="icon" />
								<div class="t">科学鉴证·确真</div>
								<div class="t2">结合高倍微观物证与专家背书，出具权威鉴定报告，让真品无懈可击。</div>
							</li>
						</el-col>
						<el-col :xs="24" :sm="24" :md="12" :lg="8">
							<li class="vcenter">
								<img src="@/static/z-icon-s2.png" class="icon" />
								<div class="t">区块链存证·确权</div>
								<div class="t2">将权属信息写入不可篡改的分布式账本，每一次流转都有迹可循。</div>
							</li>
						</el-col>
						<el-col :xs="24" :sm="24" :md="12" :lg="8">
							<li class="vcenter noline">
								<img src="@/static/z-icon-s3.png" class="icon" />
								<div class="t">全息模型评估·确价</div>
								<div class="t2">综合学术、社会、市场等多维价值，为您的资产提供科学的价值参考。</div>
							</li>
						</el-col>
					</el-row>

				</ul>
			</div>
		</div>

		<div class="main-jglist mx1360">
			<div class="title">被以下机构<span class="green">信赖与采纳</span></div>
			<div class="list">
				<el-row :gutter="25" :type="colwrap?'':'flex'">
					<el-col :xs="6" :sm="6" :md="6" :lg="6" v-for="v, k in partnerlist" :key="k">
						<div class="item vcenter">
							<img :src="v.fileList[0].url" class="p cover" />
						</div>
					</el-col>
				</el-row>
			</div>
		</div> -->
		<myfooter></myfooter>
	</div>
</template>

<script>
let that;
import ty from "@/utils/ty/ty"
import util from "@/common/util.js"
import openvip from "@/components/openVip/openVip"
export default {
	name: "index",
	data() {
		return {
			baseInfo: {
				cnt1: 0,
				cnt2: 0,
				cnt3: 0,

			},
			prolist: [],
			partnerlist: [],
			artslist: [],
		};
	},

	created() {
		that = this;
	},
	mounted() {
		this.initData();
		this.getprolist();
		this.getArts();
	},
	methods: {
		goDetail(e) {
			console.log(e)
			if (e.certificate_no) {
				util.tourl("/assetdetail", { certificate_no: e.certificate_no })
			} else {
				// util.vmsg("此艺术品尚未登记证书")
				util.valert("此艺术品尚未登记证书")

			}
		},
		getArts() {
			ty.ajax('web/web/search-list', {}).then((result) => {
				this.artslist = result.data.data.splice(0, 4)
			});
		},
		goPage(path) {
			util.tourl(path)
		},
		initData() {
			ty.ajax('web/web/indexs', {}).then((result) => {
				that.baseInfo.cnt1 = result.data.cnt1;
				that.baseInfo.cnt2 = result.data.cnt2;
				that.baseInfo.cnt3 = result.data.cnt3;
				that.partnerlist = result.data.data
			});
		},
		getprolist() {
			ty.ajax('web/web/about-us', {}).then((result) => {
				that.prolist = result.data.data1
			});
		}
	},
};
</script>

<style lang="scss">
@import '../style.scss'; //所有页面公用
@import './index.scss';
</style>